// extracted by mini-css-extract-plugin
module.exports = {"ArticleDate":"ArticleDate_ArticleDate__3QD3S"};